import orders from "./components/orders"

export default {
    orders,
}